import { Environment } from './environment.types';

export const environment: Environment = {
    environment: 'development',
    apiUrl: 'https://api.docentes.dev.fabrica.inf.ufg.br',
    featureFlags: {
        enableStateSelection: true,
        enableMunicipalitySelection: true,
        showD3I5: true,
        showD2I3: true,
        enableAnalyticalVisualizations: true,
    },
};
